<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
            <iq-card>
                <template v-slot:body>
                      <b-row>
                        <b-col class="pb-2">
                            <b-button variant="primary" @click="pdfExport" class="mr-2 float-right">
                            {{  $t('globalTrans.export_pdf') }}
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col xl="6" lg="6" sm="6">
                            <span class="text-dark">{{$t('institute_manangement.organization_name')}} : {{ getOrgName(detailsFormData.org_id) }}</span> <br>
                            <span class="text-dark">{{$t('institute_manangement.institute_type')}} : {{ getInstituteType(detailsFormData.office_type_id) }}</span>
                        </b-col>
                        <b-col xl="6" lg="6" sm="6">
                            <span class="text-dark">{{$t('institute_manangement.institute_name')}} : {{ getInstituteName(detailsFormData.office_id) }}</span> <br>
                            <span class="text-dark">{{$t('child_configuration.committee_type')}} : {{ getCommitteeType(detailsFormData.committee_type_id) }}</span>
                        </b-col>
                        <b-col xl="6" lg="6" sm="6">
                            <span class="text-dark">{{$t('child_configuration.committee_name')}} : {{ getCommitteeName(detailsFormData.committee_id) }}</span> <br>
                            <span class="text-dark">{{$t('institute_manangement.formation_date')}} : {{ detailsFormData.formation_date | dateFormat }}</span>
                        </b-col>
                        <b-col xl="6" lg="6" sm="6">
                            <span class="text-dark">{{$t('institute_manangement.tenure_committee')}} : {{ detailsFormData.tenure_date | dateFormat }}</span> <br>
                            <span class="text-dark">{{$t('globalTrans.remarks')}} : {{ (currentLocale == 'bn') ? detailsFormData.remark_bn : detailsFormData.remark_en }}</span>
                        </b-col>
                    </b-row>
                    <hr style="bg-color:green">
                    <b-row>
                        <b-col xl="12" lg="12" sm="12">
                            <table class="table table-bordered">
                                <tr class="bg-light">
                                    <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                    <th>{{ $t('child_configuration.committee_member') }}</th>
                                    <th>{{ $t('child_configuration.committee_designation') }}</th>
                                    <th v-if="detailsFormData.details[0].photo">{{ $t('child_reports.photo') }}</th>
                                </tr>
                                <b-tr v-for="(item, index) in detailsFormData.details" :key="index">
                                    <td>{{ $n(index + 1) }}</td>
                                    <b-td>{{ (currentLocale == 'bn') ? item.committee_member_bn : item.committee_member_en }}</b-td>
                                    <b-td>{{ getDesignationName(item.committee_designation_id) }}</b-td>
                                    <b-td v-if="item.photo">
                                    <b-img width='90px' height="90px" :src="url+'download-attachment?file=uploads/institute-management/original/' + item.photo" alt="Photo"></b-img>
                                    </b-td>
                                </b-tr>
                            </table>
                            <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-2')">{{ $t('globalTrans.close') }}</b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { core } from '../../../../../config/pluginInit'
import { childServiceBaseUrl } from '@/config/api_config'
import ExportPdf from './export-pdf_details'

export default {
    props: ['id'],
    components: {
    },
    created () {
        if (this.id) {
            const tmp = this.getManagementInfoData()
            this.detailsFormData = tmp
        }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            detailsFormData: {},
            url: childServiceBaseUrl
        }
    },
    computed: {
        orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        },
        committeeTypeList: function () {
            return this.childCommonObj.committeeTypList
        },
        currentLocale () {
            return this.$i18n.locale
        },
        ...mapGetters({
            childCommonObj: 'ChildService/commonObj'
        })
    },
    methods: {
        getManagementInfoData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        getOrgName (orgId) {
            const organization = this.orgList.find(org => org.value === orgId)
            if (this.$i18n.locale === 'bn') {
                return organization.text_bn
            } else {
               return organization.text_en
            }
        },
        getInstituteType (typeId) {
            const institute = this.$store.state.commonObj.officeTypeList.find(institute => institute.value === typeId)
            if (this.$i18n.locale === 'bn') {
                return institute.text_bn
            } else {
               return institute.text_en
            }
        },
        getInstituteName (InstId) {
            const institute = this.$store.state.commonObj.officeList.find(institute => institute.value === InstId)
            if (this.$i18n.locale === 'bn') {
                return institute.text_bn
            } else {
               return institute.text_en
            }
        },
        getCommitteeName (ComId) {
            const committee = this.childCommonObj.committeeNameList.find(committee => committee.value === ComId)
            if (this.$i18n.locale === 'bn') {
                return committee.text_bn
            } else {
               return committee.text_en
            }
        },
        getCommitteeType (ComId) {
            const committee = this.committeeTypeList.find(committee => committee.value === ComId)
            if (this.$i18n.locale === 'bn') {
                return committee.text_bn
            } else {
               return committee.text_en
            }
        },
        getDesignationName (desId) {
            const designation = this.childCommonObj.committeeDesignationList.find(designation => designation.value === desId)
            if (this.$i18n.locale === 'bn') {
                return designation.text_bn
            } else {
               return designation.text_en
            }
        },
         pdfExport () {
            const reportTitle = this.$t('institute_manangement.committee_member_details')
            ExportPdf.exportPdfDetails(childServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, this.detailsFormData, this)
        }
    }
}

</script>
